import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  rounded: {
    borderRadius: 10,
  },
  card: {
    padding: 8,
    borderWidth: 2,
    borderBottomWidth: 4,
  },
  keyboardKeyIndicatorContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: -14,
    zIndex: 2,
    justifyContent: 'center',
  },
});
